import { render, staticRenderFns } from "./screen-card-weather.vue?vue&type=template&id=38227191&scoped=true"
import script from "./screen-card-weather.vue?vue&type=script&lang=ts"
export * from "./screen-card-weather.vue?vue&type=script&lang=ts"
import style0 from "./screen-card-weather.vue?vue&type=style&index=0&id=38227191&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38227191",
  null
  
)

export default component.exports